import { useEffect, useState } from 'react';

import { ViewportSize } from '@/styles/viewportSize';

function getCurrentViewportSize(width: number): ViewportSize {
  if (width < ViewportSize.sm) {
    return ViewportSize.xs;
  } else if (width > ViewportSize.sm && width < ViewportSize.md) {
    return ViewportSize.sm;
  } else if (width > ViewportSize.md && width < ViewportSize.lg) {
    return ViewportSize.md;
  } else if (width > ViewportSize.lg && width < ViewportSize.xl) {
    return ViewportSize.lg;
  } else {
    return ViewportSize.xl;
  }
}

export interface UseViewportSizeType {
  viewportWidth: number;
  isMobile: boolean;
  isExtraSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isExtraLarge: boolean;
  viewportSize: ViewportSize;
}

// Hook that returns the current viewport size name along with booleans for each viewport size
export default function useViewPortSize(): UseViewportSizeType {
  const [viewportWidth, setViewportWidth] = useState(0);
  const handleWindowSizeChange = () => {
    setViewportWidth(window?.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const viewportSize = getCurrentViewportSize(viewportWidth);
  return {
    viewportWidth,
    viewportSize,
    isMobile: viewportWidth < ViewportSize.md,
    isExtraSmall: viewportSize === ViewportSize.xs,
    isSmall: viewportSize === ViewportSize.sm,
    isMedium: viewportSize === ViewportSize.md,
    isLarge: viewportSize === ViewportSize.lg,
    isExtraLarge: viewportSize === ViewportSize.xl,
  };
}
